<template>
  <div class="activity width1280">
    <img src="../assets/img/flower.png" class="flower1" alt />
    <img src="../assets/img/flower.png" class="flower2" alt />
    <img src="../assets/img/flower.png" class="flower3" alt />
    <iframe height="0px" width="0px" style="position: absolute;top:-2000px;" :src="iframeSrc" />
    <div class="content">
      <div class="top">
        <p class="name">{{userName}}</p>
        <img src="../assets/img/title.svg" alt class="pc" />
        <img src="../assets/img/p-title1.svg" alt class="phone img1" />
        <img src="../assets/img/p-title2.svg" alt class="phone img2" />
        <div class="rect"></div>
        <p class="des">
          现在注册，免费享有{{curMonth>0?5:30}}天会员福利
          <br />海量权限只待你解锁！
        </p>
        <button class="btn" @click="goHanabi">立即注册</button>
      </div>
      <div class="pan">
        <div class="logo-baner">
          <div class="line"></div>
          <img src="../assets/img/logo.svg" alt />
          <div class="line"></div>
        </div>
        <div class="item-title">在线数据短视频制作工具</div>
        <div class="text">
          90+图表，每周更新
          <br />支持PNG、JPG、SVG、GIF、MP4、MOV
          <br />静如花，动如火，视频图表、动态图表、交互图表
          <br />做好看的图表快来花火Hanabi!
        </div>
        <div class="item-title">花火最新上线图表</div>
        <div class="new">
          <div class="video" v-for="item in newList" :key="item.name">
            <!-- <video
                  loop
                  muted
                  autoplay
                  playsinline 
                  preload="auto"
                  x5-playsinline
                  webkit-playsinline
                  height="100%"
                  :src="item.url" 
                  width="100%"
            ></video>-->
            <img :src="item.url" alt />
            <p class="name">{{item.name}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
export default {
  name: "activity",
  data() {
    return {
      userName: "",
      iframeSrc: "",
      code: "",
      curMonth:new Date().getMonth(),
      newList: [
        {
          name: "动态瀑布图",
          url: "/newChart/1.gif"
        },
        {
          name: "动态柱状图",
          url: "/newChart/2.gif"
        },
        {
          name: "动态条形图",
          url: "/newChart/3.gif"
        },
        {
          name: "动态气泡图",
          url: "/newChart/4.gif"
        },
        {
          name: "动态折线图",
          url: "/newChart/5.gif"
        },
        {
          name: "动态排名图",
          url: "/newChart/6.gif"
        }
      ]
    };
  },
  methods: {
    getUserInfo() {
      let url = localStorage.apiUrl + "/api/invite/code/info?code=" + this.code;
      if (this.code) {
        this.$http.get(url).then(res => {
          if (res.data.code == 200) {
            this.userName = res.data.data.name;
          }
        });
      }
    },
    goHanabi() {
      this.$http.get(
        localStorage.apiUrl + "/api/ulog/fetch?url=a/reg&referer=activity"
      );
      window.open(
        localStorage.httpUrl + "/h2/login?code=" + this.code + "#usePhone",
        "_self"
      );
      //window.open(localStorage.httpUrl+"/register");
    }
  },
  mounted() {
    this.code = this.$route.query.code;
    this.iframeSrc = localStorage.apiUrl + "/csx/if?code=" + this.code;
    this.getUserInfo();
  },
  created() {
    this.$http.get(
      localStorage.apiUrl + "/api/ulog/fetch?url=a/idx&referer=activity"
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.activity {
  position: relative;
  padding-bottom: 180px;
  overflow: hidden;
  background-image: radial-gradient(49% 119%, #2844bb 54%, #0423a5 100%);
}
.flower1 {
  width: 660px;
  position: absolute;
  left: -100px;
  top: -200px;
}
.flower2 {
  width: 400px;
  position: absolute;
  right: -100px;
  top: 240px;
  transform: rotate(45deg);
}
.flower3 {
  width: 400px;
  position: absolute;
  left: -70px;
  bottom: 150px;
  transform: rotate(-70deg);
}
.content {
  width: 960px;
  margin: 0 auto;
  position: relative;
  z-index: 10;
}
.top {
  padding: 80px 0 60px;
  text-align: center;
  line-height: 34px;
  color: #ffffff;
}
.name {
  font-size: 26px;
}
.top img {
  height: 43px;
  display: block;
  margin: 30px auto 0;
}
.top .rect {
  width: 24px;
  height: 3px;
  margin: 20px auto 0;
  background-color: #fff;
}
.top .des {
  margin-top: 42px;
  font-size: 24px;
  line-height: 36px;
}
.btn {
  width: 180px;
  height: 48px;
  display: block;
  margin: 46px auto 0;
  cursor: pointer;
  text-align: center;
  background: #06e9ef;
  box-shadow: 0 0 10px 0 rgba(26, 56, 122, 0.6);
  border-radius: 4px;
  border: none;
  outline: none;
  line-height: 48px;
  font-size: 28px;
  color: #0423a5;
}
.pan {
  padding-top: 40px;
  background: #ffffff;
  border-radius: 8px;
}
.logo-baner {
  width: 600px;
  margin: 0 auto 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-baner .line {
  width: 120px;
  border-bottom: 1px solid #0423a5;
}
.logo-baner img {
  height: 63px;
  width: 300px;
  position: relative;
  top: -10px;
}
.item-title {
  font-size: 24px;
  color: #0423a5;
  text-align: center;
  line-height: 33px;
}
.item-title:after {
  display: block;
  content: "";
  height: 6px;
  width: 40px;
  margin: 8px auto 0;
  background: #06e9ef;
}
.text {
  margin: 22px auto 54px;
  font-size: 20px;
  color: #0423a5;
  text-align: center;
  line-height: 36px;
}
.new {
  width: 726px;
  margin: 20px auto 0;
  padding-bottom: 22px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.video {
  width: 210px;
  height: 192px;
  box-shadow: 0 0 20px 0 rgba(191, 191, 191, 0.5);
  margin-bottom: 40px;
}
.video video,
.video img {
  height: 152px;
  width: 100%;
}
.video .name {
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #445b84;
}
.bottom {
  height: 174px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: url("../assets/img/bottom.png") repeat-x;
}

@media screen and (max-width: 600px) {
  .pc {
    display: none !important;
  }
  .phone {
    display: block;
  }
  .width1280 {
    width: 100%;
  }
  .activity {
    padding-bottom: 2.4rem;
  }
  .flower1 {
    width: 7.666667rem;
    height: 8.053333rem;
    top: -2.666667rem;
  }
  .flower2 {
    width: 5.333333rem;
  }
  .flower3 {
    left: -130px;
    bottom: 400px;
  }
  .top {
    padding: 0.693333rem 0 0.933333rem;
  }
  .name {
    font-size: 0.373333rem;
    line-height: 0.506667rem;
  }
  .content {
    width: 100%;
  }
  .top .img1 {
    height: 0.64rem;
    margin-top: 0.48rem;
  }
  .top .img2 {
    height: 1.12rem;
    margin-top: 0.466667rem;
  }
  .top .rect {
    height: 0.066667rem;
    width: 0.533333rem;
    margin-top: 0.72rem;
  }
  .top .des {
    margin-top: 0.533333rem;
    font-size: 0.346667rem;
    line-height: 0.533333rem;
  }
  .btn {
    height: 0.8rem;
    width: 3.2rem;
    margin-top: 0.973333rem;
    line-height: 0.8rem;
    font-size: 0.453333rem;
  }
  .pan {
    width: 8.933333rem;
    margin: 0.933333rem auto 0;
    padding-top: 0.8rem;
  }
  .logo-baner {
    width: 6.666667rem;
    margin-bottom: 1rem;
  }
  .logo-baner .line {
    width: 1.066667rem;
  }
  .logo-baner img {
    height: 0.56rem;
    width: auto;
    top: -0.133333rem;
  }
  .item-title {
    font-size: 0.4rem;
    line-height: 0.56rem;
    color: #0423a5;
  }
  .item-title:after {
    width: 0.533333rem;
    height: 0.08rem;
    margin-top: 0.266667rem;
  }
  .text {
    margin: 0.426667rem 0 0.8rem;
    line-height: 0.48rem;
    font-size: 0.293333rem;
  }
  .new {
    width: 8rem;
    justify-content: space-between;
  }
  .video {
    width: 3.733333rem;
    height: 3.466667rem;
  }
  .video video,
  .video img {
    height: 2.666667rem;
  }
  .video .name {
    line-height: 0.8rem;
    font-size: 0.266667rem;
  }
}
</style>
